import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import DashboardLayout from './layouts/DashboardLayout';
import DailyMeetingPage from './dailyMeeting/DailyMeetingPage';
import ScaleDataPage from './scale/ScaleDataPage';
import PickupDashboardPage from './pickup/PickupDashboardPage';
import SortingDashboardPage from './sorting/SortingDashboardPage';
import NoUpdateDashboardPage from './sorting/NoUpdateDashboardPage';
import TransportationDataPage from './transportation/TransportationDataPage';
import DeliveryDataPage from './delivery/DeliveryDataPage';
import DashboardReportFilePage from './download/DashboardReportFilePage';

const DashboardRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><DashboardLayout /></AuthGuard>}>
                <Route path="daily-meeting" element={<DailyMeetingPage />} />
                <Route path="scale" element={<ScaleDataPage />} />
                <Route path="pickup" element={<PickupDashboardPage />} />
                <Route path="sorting" element={<SortingDashboardPage />} />
                <Route path="transportation" element={<TransportationDataPage />} />
                <Route path="delivery" element={<DeliveryDataPage />} />
                <Route path="quality" element={<NoUpdateDashboardPage />} />
                <Route path="download" element={<DashboardReportFilePage />} />
            </Route>
        </Routes>
    );
};

export default DashboardRoutes;
